import { makeStyles } from '@material-ui/styles';
import { Button, Icon } from 'antd';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 100,
    marginLeft: -12,
    padding: '5px 16px',
    color: theme.colors.bodyColor,
    fontWeight: 600,
    border: 0,
    boxShadow: 'none',
  },
}));

const BackBtn = ({ className, text, onClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button ghost className={classNames(classes.root, className)} onClick={onClick}>
      <Icon type="arrow-left" />
      {text ?? t('global.btn.back')}
    </Button>
  );
};

BackBtn.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default BackBtn;
